import * as React from 'react';

import { cn } from '../../../lib/utils';
import { Badge } from '../../ui/badge';

export interface StatusBadgeProps<T extends string> {
  /** Optional additional CSS classes */
  className?: string;
  /** The translated label to show inside the badge */
  label: string;
  /** The status value used to look up the style */
  status: T;
  /** A record mapping each status value to a Tailwind class string */
  styles: Record<T, string>;
}

export function StatusBadge<T extends string>({
  className,
  label,
  status,
  styles,
}: StatusBadgeProps<T>): React.JSX.Element {
  return (
    <Badge className={cn('w-fit', styles[status], className)} variant="outline">
      {label}
    </Badge>
  );
}
